import { getFormattedPrice, type LocalPricingT } from '@mentimeter/billing';
import { PlanCategory } from '@mentimeter/http-clients';

export function getAmountsForBasic({
  isEducation,
  monthlyToggled,
  prices,
}: {
  isEducation: boolean;
  monthlyToggled: boolean;
  prices: LocalPricingT;
}) {
  if (isEducation && monthlyToggled) {
    return prices.plans[PlanCategory.EDUCATIONAL_BASIC_MONTHLY].amount;
  }

  if (isEducation && !monthlyToggled) {
    return prices.plans[PlanCategory.EDUCATIONAL_BASIC].amount;
  }

  if (!isEducation && monthlyToggled) {
    return prices.plans[PlanCategory.BASIC_MONTHLY].amount;
  }
  return prices.plans[PlanCategory.BASIC].amount;
}

export function getFormattedPricesForBasic({
  isEducation,
  monthlyToggled,
  prices,
}: {
  isEducation: boolean;
  monthlyToggled: boolean;
  prices: LocalPricingT;
}) {
  if (isEducation) {
    return getFormattedPrice(
      getAmountsForBasic({ isEducation, monthlyToggled, prices }),
      prices.currency.symbol,
      prices.format,
    );
  }

  return getFormattedPrice(
    getAmountsForBasic({ isEducation, monthlyToggled, prices }),
    prices.currency.symbol,
    prices.format,
  );
}

export const calculateBasicDiscount = (
  isEducation: boolean,
  monthlyToggled: boolean,
  prices: LocalPricingT,
) => {
  const monthlyPrice =
    getAmountsForBasic({
      isEducation,
      monthlyToggled: true,
      prices,
    }) || 0;
  const yearlyPricePerMonth =
    getAmountsForBasic({
      isEducation,
      monthlyToggled,
      prices,
    }) || 0;
  const discountPrice = 1 - yearlyPricePerMonth / monthlyPrice;
  const ceiledDiscountPrice = Math.ceil(discountPrice * 100);
  return `${ceiledDiscountPrice}%`;
};
